"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applySplit = void 0;
const utilityFunctions_1 = require("../../utilities/utilityFunctions");
function applySplit(factory, src, separatorOrPredicate) {
    function* generator() {
        let chunk = [];
        let i = 0;
        for (const item of src) {
            if ((typeof separatorOrPredicate === 'function' &&
                separatorOrPredicate(item, i)) ||
                (typeof separatorOrPredicate !== 'function' && item === separatorOrPredicate)) {
                yield factory.createArrayEnumerable((0, utilityFunctions_1.getIterableGenerator)(chunk), chunk);
                chunk = [];
            }
            else {
                chunk.push(item);
            }
            i++;
        }
        if (chunk.length > 0) {
            yield factory.createArrayEnumerable((0, utilityFunctions_1.getIterableGenerator)(chunk), chunk);
        }
    }
    return factory.createBasicEnumerable(generator);
}
exports.applySplit = applySplit;
//# sourceMappingURL=applySplit.js.map